class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.selectors = {
      searchQuery: "[data-query]",
      searchMessage: "[data-message]",
      input: "[data-search-input]",
      submit: 'button[type="submit"]',
      loading: "[data-spinner]",
      clear: "[data-clear-search]",
      popularSearchItems: ["[data-ps-item]"],
      moreResultIcon: "[data-more-result-icon]",
    };

    this.container = document.querySelector("[data-search-popup]");

    this.domNodes = queryDomNodes(this.selectors, this.container);

    this.cachedResults = {};
    this.transitionDuration = 300;
    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector("[data-predictive-search]");
    this.searchPopupSearults = this.querySelector(".m-search-popup__result");
    this.popularSearches = this.querySelector("[data-popular-searches]");
    this.searchCount = this.querySelector("[data-search-count]");

    this.setupEventListeners();
  }

  setPopularSearchesLink = () => {
    const { popularSearchItems } = this.domNodes;
    popularSearchItems.forEach((itm) => (itm.href = createSearchLink(itm.dataset.psQuery)));
  };

  setupEventListeners() {
    const { clear } = this.domNodes;
    const form = this.querySelector("form.m-search-form");
    form.addEventListener("submit", this.onFormSubmit.bind(this));

    this.input.addEventListener(
      "input",
      debounce((event) => {
        this.onChange(event);
      }, 300).bind(this)
    );
    if (clear) clear.addEventListener("click", this.onClearSearch.bind(this));
    MinimogEvents.subscribe(MinimogTheme.pubSubEvents.closeSearchPopup, () => this.close(true));
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    const searchTerm = this.getQuery();

    if (!searchTerm.length) {
      this.close(true);
      return;
    }

    this.getSearchResults(searchTerm);
  }

  onFormSubmit(event) {
    if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) event.preventDefault();
  }

  onClearSearch(event) {
    event.preventDefault();
    this.input.value = "";
    this.onChange();
  }

  getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(" ", "-").toLowerCase();
    this.toggleSpinnerLoading(true);
    this.toggleClearSearch(false);

    const unavailableProductsOption = this.dataset.unavailableProductsOption || "last";

    let searchFields = "title";

    if (this.cachedResults[queryKey]) {
      this.renderSearchResults(this.cachedResults[queryKey]);
      return;
    }

    let searchURL = `${window.MinimogSettings.routes.predictive_search_url}?q=${encodeURIComponent(
      searchTerm
    )}&resources[type]=product&resources[limit]=20&resources[options][unavailable_products]=${unavailableProductsOption}&resources[options][fields]=title&section_id=predictive-search`;

    fetch(`${searchURL}`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }
        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, "text/html")
          .querySelector("#shopify-section-predictive-search").innerHTML;
        this.cachedResults[queryKey] = resultsMarkup;
        this.renderSearchResults(resultsMarkup);
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;
    this.setAttribute("results", true);

    const query = this.getQuery().toLowerCase().trim();
    if (query) {
      const queryWords = query.split(/\s+/).filter(Boolean);
      const productItems = this.querySelectorAll(".m-search-result__product-item");
      let visibleCount = 0;

      productItems.forEach((item) => {
        let title = (item.dataset.productTitle || "").toLowerCase().trim();
        if (!title) {
          const titleEl = item.querySelector(".m-product-card__name, .m-product-card__title a, a[href*='/products/']");
          if (titleEl) title = titleEl.textContent.toLowerCase().trim();
        }

        let isMatch = false;
        if (title.includes(query)) {
          isMatch = true;
        } else if (queryWords.length > 0 && queryWords.every((word) => title.includes(word))) {
          isMatch = true;
        }

        if (isMatch) {
          item.style.display = "";
          visibleCount++;
        } else {
          item.remove();
        }
      });

      const groupWrapper = this.querySelector(".m-search-result__group-wrapper");
      if (visibleCount === 0) {
        if (groupWrapper) groupWrapper.style.display = "none";
        let noResultsMsg = this.querySelector(".gfa-no-results-msg");
        if (!noResultsMsg) {
          noResultsMsg = document.createElement("div");
          noResultsMsg.className = "gfa-no-results-msg";
          const wrapper = this.querySelector("[data-search-items-wrapper]") || this.predictiveSearchResults;
          wrapper.appendChild(noResultsMsg);
        }
        noResultsMsg.innerHTML = `<p>No products found for "${this.getQuery()}"</p>`;
        noResultsMsg.style.display = "block";
      } else {
        if (groupWrapper) groupWrapper.style.display = "";
        const noResultsMsg = this.querySelector(".gfa-no-results-msg");
        if (noResultsMsg) noResultsMsg.style.display = "none";
      }
    }

    const searchItemsWrapper = this.querySelector("[data-search-items-wrapper]");
    if (searchItemsWrapper && searchItemsWrapper.querySelector(".m-search-result__product-item")) {
      this.renderSearchQueryAndMessage(true);
    } else {
      this.renderSearchQueryAndMessage(false);
    }

    this.toggleSpinnerLoading(false);
    this.toggleClearSearch(true);
    this.open();
  }

  renderSearchQueryAndMessage(results) {
    const { input, searchQuery, searchMessage, moreResultIcon } = this.domNodes;
    const query = input.value;

    if (searchMessage && searchQuery) {
      const { resultsTitle } = searchMessage.dataset;
      searchQuery.textContent = query;

      if (results) {
        searchMessage.textContent = resultsTitle;
        if (moreResultIcon) moreResultIcon.classList.add("m:hidden");
      } else {
        searchMessage.textContent = searchMessage.dataset.resultsTitle;
        if (moreResultIcon) moreResultIcon.classList.remove("m:hidden");
      }
    }

    this.predictiveSearchResults.classList.remove("m:hidden");
    this.searchPopupSearults.classList.remove("m:hidden");
  }

  toggleSpinnerLoading(show) {
    const { loading, submit } = this.domNodes;
    if (submit) submit.style.visibility = show ? "hidden" : "visible";
    if (loading) loading.style.visibility = show ? "visible" : "hidden";
  }

  toggleClearSearch(show) {
    const { clear } = this.domNodes;
    if (clear) clear.style.visibility = show ? "visible" : "hidden";
  }

  open() {
    if (this.searchPopupSearults) {
      this.searchPopupSearults.style.setProperty(
        "--search-result-max-height",
        `${this.resultsMaxHeight || this.getResultsMaxHeight()}px`
      );
    }
    this.setAttribute("open", true);
    if (this.input) this.input.setAttribute("aria-expanded", true);
    this.isOpen = true;

    if (this.popularSearches) this.popularSearches.classList.add("m:hidden");
    if (this.searchCount) this.searchCount.classList.remove("m:hidden");
  }

  close(clearSearchTerm = false) {
    if (clearSearchTerm) {
      if (this.input) this.input.value = "";
      this.removeAttribute("results");
      this.toggleClearSearch(false);
      this.resultsMaxHeight = false;
    }

    this.removeAttribute("open");
    if (this.predictiveSearchResults) this.predictiveSearchResults.classList.add("m:hidden");
    if (this.searchPopupSearults) this.searchPopupSearults.classList.add("m:hidden");
    if (this.popularSearches) this.popularSearches.classList.remove("m:hidden");
    if (this.searchCount) this.searchCount.classList.add("m:hidden");
  }

  getResultsMaxHeight() {
    this.resultsMaxHeight =
      window.innerHeight - document.querySelector("predictive-search").getBoundingClientRect().bottom;
    return this.resultsMaxHeight;
  }
}

customElements.define("predictive-search", PredictiveSearch);
